import { useState, useEffect } from 'react';
import { FaTimes, FaCheck } from 'react-icons/fa';
import apiService from 'services/apiService';
import { toast } from 'react-toastify';
import ReasonOfRejection from 'components/common/reasonOfRejection/ReasonOfRejection';
import ContractConfirmation from 'components/common/contractConfirmation/ContractConfirmation';
import SignatureModal from 'components/common/signatureModal';
import pdfIcon from '../../assets/images/pdfIcons.svg';
import docIcon from '../../assets/images/docIcon.svg';
import DatePicker from 'components/common/datePicker/DatePicker';
import { useLocation, useNavigate } from 'react-router-dom';

const contractType = [
  { label: 'Full Time', value: 'full_time' },
  { label: 'Part Time', value: 'part_time' },
];

const ContractDetail = () => {
  const [contractDetails, setContractDetails] = useState(null);
  const [user, setUser] = useState(null);
  const [rejectionModal, setRejectionModal] = useState(false);
  const [signatureModal, setSignatureModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [isAcceptContract, setIsAcceptContract] = useState(1);
  const [contractUpdateLoading, setContractUpdateLoading] = useState(false);
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [depndency, setDepndency] = useState(false);
  const [rejectionReasonModal, setRejectionReasonModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userDetail = JSON.parse(localStorage.getItem('user'));
    const savedData = JSON.parse(localStorage.getItem('rowOriginalData'));
    setContractDetails(savedData);
    setUser(userDetail);
  }, [depndency]);

  const JoiningdateApply = async (e) => {
    const payload = { joining_date: e };

    try {
      const dateApply = await apiService.put(
        `contracts/${contractDetails?._id}/update-joining-date`,
        payload
      );

      console.log('dateApplydateApply', dateApply?.code);

      if (dateApply?.code === 200) {
        // Assuming successful response
        toast.success('Joining date updated successfully!');
        navigate('/Contracts');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to update joining date. Please try again.');
    }
  };

  const calculateDuration = (startDateStr, endDateStr) => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    if (endDate < startDate) {
      return 'End date must be after start date.';
    }

    // Calculate differences
    const differenceInMs = endDate - startDate;

    // Constants for conversions
    const millisecondsInADay = 24 * 60 * 60 * 1000;
    const millisecondsInAMonth = millisecondsInADay * 30.44; // Approximate average month
    const millisecondsInAYear = millisecondsInADay * 365.25; // Approximate average year

    // Convert to meaningful units
    const years = Math.floor(differenceInMs / millisecondsInAYear);
    const months = Math.floor(differenceInMs / millisecondsInAMonth);
    const days = Math.floor(differenceInMs / millisecondsInADay);

    // Decide the most meaningful unit
    if (years > 0) {
      return years === 1 ? `${years} year` : `${years} years`;
    } else if (months > 0) {
      return months === 1 ? `${months} month` : `${months} months`;
    } else {
      return days === 1 ? `${days} day` : `${days} days`;
    }
  };

  const updateContractStatus = async (payload, isAccepted) => {
    setContractUpdateLoading(true);
    try {
      const response = await apiService.put(`contracts/update-status`, payload);
      const contractDetailResponse = await apiService.get(
        `contracts/${contractDetails?._id}`
      );
      setContractUpdateLoading(false);
      if (response?.code === 200) {
        setContractDetails(contractDetailResponse?.data);
        const status = isAccepted ? 'accepted' : 'rejected';
        if (isAccepted) {
          setSignatureModal(false);
        }
        toast[isAccepted ? 'success' : 'info'](`Contract is ${status}`, {
          toastId: '19',
        });
      }
    } catch (error) {
      setContractUpdateLoading(false);
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Unexpected Error',
        { toastId: '98' }
      );
      console.error(error);
    }
  };

  const handleReject = (rejectionReason) => {
    setRejectionModal(false);
    let payload = {
      contract_id: contractDetails?._id,
      status: 'rejected',
      reason: rejectionReason,
    };
    updateContractStatus(payload, false);
  };

  const onReject = () => {
    setRejectionModal(true);
  };

  const onAccept = () => {
    setConfirmationModal(false);
    setRejectionModal(false);
    setTimeout(() => {
      setSignatureModal(true);
    }, 300);
  };

  const updateStatusConfirmation = (isAccept) => {
    setIsAcceptContract(isAccept);
    setConfirmationModal(true);
  };

  const getLabelByValue = (value) => {
    const contract = contractType.find((item) => item.value === value);
    return contract ? contract.label : null; // Return null if value is not found
  };

  const acceptWithSign = (finalFile) => {
    let payload = {
      contract_id: contractDetails?._id,
      status: 'approved',
      reason: '',
      physician_signature: finalFile,
    };
    updateContractStatus(payload, true);
  };

  const renderFile = (file) => {
    const filePath = file;
    const fileExtension = filePath?.split?.('.')?.pop()?.toLowerCase(); // Get the file extension

    let fileIcon = null;

    // Check file type and assign the appropriate icon
    if (fileExtension === 'pdf') {
      fileIcon = pdfIcon; // Set PDF icon
    } else if (fileExtension === 'doc' || fileExtension === 'docx') {
      fileIcon = docIcon; // Set DOC icon
    }
    return (
      <div
        key={file.path}
        className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
      >
        {fileIcon && (
          <img
            src={fileIcon}
            alt="file icon"
            className="w-[40px] h-[40px] flex-shrink-0"
          />
        )}

        <div className="flex flex-col w-full">
          <div className="flex justify-between items-center w-full">
            <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
              {filePath}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const toggleCalendar = () => {
    setCalendarVisible(!calendarVisible);
  };

  const minDate = contractDetails?.start_date
    ? new Date(contractDetails.start_date)
    : null;
  const maxDate = contractDetails?.end_date
    ? new Date(contractDetails.end_date)
    : null;

  return (
    <>
      {signatureModal && (
        <SignatureModal
          setFinalFile={acceptWithSign}
          setIsToggledModal={setSignatureModal}
        />
      )}

      {rejectionReasonModal && (
        <ContractConfirmation
          isAccept={3}
          onDismiss={() => {
            setRejectionReasonModal(false);
          }}
          contractDetails={{ reason: contractDetails?.termination_reason }}
        ></ContractConfirmation>
      )}

      {confirmationModal && (
        <ContractConfirmation
          onConfirm={() => {
            if (isAcceptContract === 2) {
              onAccept();
            } else if (isAcceptContract === 1) {
              onReject();
            }
            setTimeout(() => {
              setConfirmationModal(false);
            }, 700);
          }}
          isAccept={isAcceptContract}
          contractDetails={contractDetails}
          onDismiss={() => setConfirmationModal(false)}
        />
      )}

      {rejectionModal && (
        <ReasonOfRejection
          setRejection={setRejectionModal}
          rejectionReason={handleReject}
        />
      )}
      <div className="bg-white rounded-lg p-6">
        {contractDetails?.status == 'pending' &&
          user?.role === 'physician_management' && (
            <div className="flex justify-end gap-4 p-4">
              {/* Reject Button */}
              <button
                disabled={contractUpdateLoading}
                onClick={() => updateStatusConfirmation(1)}
                className="flex items-center justify-center gap-2 px-4 py-2 text-[#DF1C41] border-1 border-[#DF1C41] rounded-md hover:bg-red-50 focus:outline-none focus:ring focus:ring-red-200"
              >
                <FaTimes className="text-l" /> {/* Reject Icon */}
                Reject
              </button>

              {/* Accept Button */}
              <button
                disabled={contractUpdateLoading}
                onClick={() => updateStatusConfirmation(2)}
                className="flex items-center justify-center gap-2 px-4 py-2 text-white bg-[#2D9F75] rounded-md hover:bg-green-700 focus:outline-none focus:ring focus:ring-green-300"
              >
                <FaCheck className="text-l" />
                Accept
              </button>
            </div>
          )}
        {contractDetails?.status === 'rejected' && (
          <div className="flex justify-end p-2">
            {/* Reject Button */}
            <button
              disabled={contractUpdateLoading}
              onClick={() => updateStatusConfirmation(3)}
              className="flex items-center justify-center gap-2 px-4 py-2 text-[#DF1C41] border-1 border-[#DF1C41] rounded-md hover:bg-red-50 focus:outline-none focus:ring focus:ring-red-200"
            >
              {/* <FaTimes className="text-l" /> */}
              Show reason of rejection
            </button>
          </div>
        )}
        {contractDetails?.status === 'approved' &&
          user.role === 'hospital_manager' && (
            <div className="flex justify-end p-2">
              {/* Reject Button */}
              <DatePicker
                onChange={(e, cancle) => {
                  if (e != '') {
                    JoiningdateApply(e);
                  }
                }}
                footer={
                  <button
                    onClick={JoiningdateApply}
                    className="btn btn-primary"
                  >
                    Apply
                  </button>
                }
                value={contractDetails?.joining_date}
                disabled={
                  'joining_date' in contractDetails &&
                  (contractDetails?.joining_date === null ? false : true)
                }
                minDate={minDate}
                maxDate={maxDate}
                label={'Select Joining Date'}
                placement="down"
                ShowFooter={true}
                inline // Make the calendar inline
                className="border rounded-lg shadow-lg" // Custom styles for the calendar
              />
            </div>
          )}

        <div className="border rounded  pt-6 pl-1 pr-1 pb-4">
          <div class="flex justify-between items-center border-b pb-2 pl-2 pr-2">
            <div class="flex items-center gap-2">
              <span class="flex items-center gap-1 px-2 py-1 text-sm font-semibold text-[#525866] bg-[#ffffff] border rounded">
                {/* <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="8.84082" cy="8.33105" r="3" fill="#38C793" />
                                </svg> */}
                <div
                  style={{
                    backgroundColor:
                      contractDetails?.status?.toLowerCase() == 'pending'
                        ? '#F2AE40'
                        : contractDetails?.status?.toLowerCase() == 'rejected'
                          ? '#DF1C41'
                          : contractDetails?.status?.toLowerCase() ==
                              'terminated'
                            ? '#DF1C41'
                            : '#2D9F75',
                  }}
                  class="w-2 h-2 rounded-full"
                ></div>
                {contractDetails?.status == 'pending'
                  ? 'Pending Signature'
                  : contractDetails?.status.toUpperCase()}
              </span>
              <h1 class="text-lg font-semibold ml-4 text-[#525866]">{`MOH Contract for ${contractDetails?.announced_job?.medical_speciality?.name} | ${contractDetails?.physician?.user?.firstName?.toUpperCase()} ${contractDetails?.physician?.user?.lastName?.toUpperCase()}`}</h1>
            </div>
          </div>

          <div className="mb-6">
            {/* First Row with 5 columns */}
            <div className="grid grid-cols-5 gap-4 text-sm h-[120px]">
              <div className="border-r pt-4 pl-8">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Name
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {contractDetails?.physician?.user?.firstName?.toUpperCase()}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Specility
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {contractDetails?.announced_job?.medical_speciality?.name}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Level
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {contractDetails?.announced_job?.speciality?.name}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Hospital Name
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {contractDetails?.job_requests?.creator?.sites[0]?.name}
                </p>
              </div>
              <div className="pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Region
                </p>
                <p className="text-[#AF1D38] font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {contractDetails?.job_requests?.creator?.region?.name}
                </p>
              </div>
            </div>

            {/* Second Row with 3 columns */}
            <div className="grid grid-cols-4 gap-4 text-sm border-t border-b h-[120px]">
              <div className="border-r pt-4 pl-8">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Cluster
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {contractDetails?.job_requests?.creator?.cluster?.name}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Contact No
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {contractDetails?.physician?.user?.phoneNumber}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Hourly Rate
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">{`${contractDetails?.hourly_fees} SAR`}</p>
              </div>
              <div className="pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Contract Type
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {getLabelByValue(contractDetails?.contract_type)}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-4 gap-4 text-sm border-t border-b h-[120px]">
              <div className="border-r pt-4 pl-8">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Duration
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {calculateDuration(
                    contractDetails?.start_date,
                    contractDetails?.end_date
                  )}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Start Date
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {contractDetails?.start_date &&
                    new Date(contractDetails.start_date).toLocaleDateString(
                      'en-GB'
                    )}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  End Date
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em] text-[#DF1C41]">
                  {contractDetails?.start_date &&
                    new Date(contractDetails.end_date).toLocaleDateString(
                      'en-GB'
                    )}
                </p>
              </div>
              <div className="pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Job Number
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em] ">
                  {contractDetails?.announced_job?.jobNumber}
                </p>
              </div>
            </div>
          </div>

          {/* <span className='text-[#868C98] text-[16px] font-semibold '>Job Summary </span> */}
          {contractDetails?.upload_contract?.length > 0 ? (
            <div className=" pt-1 ml-4 ">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                {renderFile(
                  typeof contractDetails?.upload_contract === 'string'
                    ? contractDetails?.upload_contract
                    : contractDetails?.upload_contract[0].path ||
                        contractDetails?.upload_contract[0]
                )}
              </div>
            </div>
          ) : (
            <div
              className="relative overflow-hidden pt-3 pl-4"
              dangerouslySetInnerHTML={{
                __html: contractDetails?.draft_contract || '',
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ContractDetail;
